import script from "./CommonBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonBackground.vue?vue&type=script&setup=true&lang=ts"

import "./CommonBackground.vue?vue&type=style&index=0&id=589d4731&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589d4731"]])

export default __exports__